module.exports = __webpack_public_path__ + "img/Fundall-MintGreen-Lockup.db8e2bc9.svg";